import React, { useEffect, useState } from "react";
import Button from "@components/Ui/Button";
import "./style.scss";

const VoucherButtons = ({ value, setValue }) => {
    const [inputValue, setInputValue] = useState(value > 0 ? String(value) : "");

    useEffect(() => {
        const stringValue = value > 0 ? String(value) : "";
        if (stringValue !== inputValue) {
            setInputValue(stringValue);
        }
    }, [value]);

    const handleInputChange = (e) => {
        const val = e.target.value;
        if (val === "") {
            setInputValue("");
            setValue(0);
            return;
        }
        if (/^\d+$/.test(val)) {
            setInputValue(val);
            setValue(parseInt(val, 10));
        }
    };


    const handleIncrement = () => {
        const newVal = (parseInt(inputValue, 10) || 0) + 1;
        setInputValue(String(newVal));
        setValue(newVal);
    };

    const handleDecrement = () => {
        const newVal = Math.max((parseInt(inputValue, 10) || 0) - 1, 0);
        setInputValue(newVal === 0 ? "" : String(newVal));
        setValue(newVal);
    };

    return (
        <div className="voucher-search__buttons">
            <Button
                additionalClasses="voucher-search__button voucher-search__button--decrement"
                onClick={handleDecrement}
            >
                -
            </Button>
            <input
                type="text"
                aria-label="quantity input"
                className="number-input__text"
                placeholder="0"
                value={inputValue}
                onChange={handleInputChange}
            />
            <Button
                additionalClasses="voucher-search__button voucher-search__button--increment"
                onClick={handleIncrement}
            >
                +
            </Button>
        </div>
    );
};

export default VoucherButtons;
